/*
 * @author: pengjun
 * @date: 2025-01-08
 * @lastEditors: pengjun
 * @lastEditTime: 2025-09-05
 * @description:
 */
export default {
  SERVICE_MAIN_DOMAIN: 'local-lsp.xiujiadian.com:8888/',
  SERVICE_SECOND_DOMAIN: 'local-lsp.xiujiadian.com:9999/',
};
